import Factory from '../di/factory';


class PageTransitionFactory extends Factory {

	constructor({container, prefix = '', suffix = 'PageTransition'}) {
		super({container: container, prefix: prefix, suffix: suffix});
    }

}


export default PageTransitionFactory;
